import React from 'react';
import { X } from 'react-feather';
import { NavLink } from 'react-router-dom';

import styles from './MigrateLayout.module.scss';

interface MigrateStep {
  label: string;
  path: string;
}

interface MigrateLayoutProps {
  title: string;
  description: string;
  handleClose: () => void;
  steps: MigrateStep[];
  children: React.ReactNode;
}

const MigrateLayout: React.FC<MigrateLayoutProps> = ({
  title,
  description,
  handleClose,
  steps,
  children
}) => {
  return (
    <main className={styles.MigrateLayout}>
      <header className={styles.MigrateLayout_header}>
        <div className={styles.MigrateLayout_header_title_box}>
          <h5>{title}</h5>
          <p>{description}</p>
        </div>
        <button className={styles.MigrateLayout_header_close_btn} onClick={handleClose}>
          <X />
        </button>
      </header>
      <div className={styles.MigrateLayout_main}>
        <nav className={styles.MigrateLayout_nav}>
          <ul className={styles.MigrateLayout_nav_list}>
            {steps.map(step => (
              <li key={step.path} className={styles.MigrateLayout_nav_item}>
                <NavLink
                  to={step.path}
                  className={({ isActive }) =>
                    isActive ? styles.MigrateLayout_nav_item_active : undefined
                  }
                >
                  {step.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
        <section className={styles.MigrateLayout_content}>{children}</section>
      </div>
    </main>
  );
};

export default MigrateLayout;
